import { render, staticRenderFns } from "./PasswordExpiredTemplate.vue?vue&type=template&id=d591aeb0&scoped=true&"
import script from "./PasswordExpiredTemplate.vue?vue&type=script&lang=js&"
export * from "./PasswordExpiredTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PasswordExpiredTemplate.vue?vue&type=style&index=0&id=d591aeb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d591aeb0",
  null
  
)

export default component.exports